/** Мутация удаления проекта. */
import { useMutation } from "@tanstack/react-query";
import { Api } from "@/api";
import { projectsKeys } from "./keys";

export const useDeleteProject = () => {
	const mutation = useMutation({
		mutationFn: Api.Project.deleteApiProjectsById,
		mutationKey: projectsKeys.delete,
	});

	return {
		execute: mutation.mutateAsync,
		isPending: mutation.isPending,
	};
};
